import React from 'react'
import {
  Route,
  Redirect,
  useParams,
  RouteProps as ReactRouteProps,
} from 'react-router-dom'

import { ColorVariables, LayerStyles, TextStyles, Symbols } from './pages'
import { Flex } from 'components/Box'
import { useFlag } from 'constants/flags'

import {
  getAllTemplatesForVersionedRoute,
  routes,
  RouteParams,
} from 'constants/routes'
import { isDocumentRoute } from 'components/Breakpoint/utils'

export const CWV_ROUTES = [
  ...getAllTemplatesForVersionedRoute('CWV_SYMBOLS'),
  ...getAllTemplatesForVersionedRoute('CWV_TEXT_STYLES'),
  ...getAllTemplatesForVersionedRoute('CWV_LAYER_STYLES'),
  ...getAllTemplatesForVersionedRoute('CWV_COLOR_VARIABLES'),
]

export const isCwvRoute = (path: string) =>
  CWV_ROUTES.find(route => route === path) || isDocumentRoute(path)

export const isCwvSpecificRoute = (
  path: string,
  route:
    | 'SHARE_VIEW'
    | 'CWV_SYMBOLS'
    | 'CWV_TEXT_STYLES'
    | 'CWV_LAYER_STYLES'
    | 'CWV_COLOR_VARIABLES'
) => !!getAllTemplatesForVersionedRoute(route).find(r => r === path)

export const CwvRoutes: React.FC<ReactRouteProps> = () => {
  const isComponentWebViewOn = useFlag('components-web-view')
  const { shareID } = useParams<RouteParams<'SHARE_VIEW'>>()

  return isComponentWebViewOn ? (
    // 51px is the CWV header height, it's a fixed header so we need to set
    // the space.
    <Flex flex="1" mt="51px">
      <Route exact path={getAllTemplatesForVersionedRoute('CWV_SYMBOLS')}>
        <Symbols />
      </Route>
      <Route exact path={getAllTemplatesForVersionedRoute('CWV_TEXT_STYLES')}>
        <TextStyles />
      </Route>
      <Route exact path={getAllTemplatesForVersionedRoute('CWV_LAYER_STYLES')}>
        <LayerStyles />
      </Route>
      <Route
        exact
        path={getAllTemplatesForVersionedRoute('CWV_COLOR_VARIABLES')}>
        <ColorVariables />
      </Route>
    </Flex>
  ) : (
    <Redirect to={routes.SHARE_VIEW.create({ shareID })} />
  )
}
